<nz-spin [nzSpinning]="loading">
  <div class="wmsm-box">
    <nz-card>
      <span class="Risklabel">{{ 'InvoiceInfo' | translate }}</span>

      <div nz-row nzGutter="50" style="margin-bottom: 10px;">
        <div nz-col nz-tooltip [nzTooltipTitle]="'TooltipAddInvoiceRow' | translate">
          <button nz-button nzType="primary" class="default-button" (click)="addRow()">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
            {{ 'Add' | translate }}
          </button>
        </div>
        <div nz-col>
          <button nz-button nzType="primary" class="default-button" (click)="returnRequest.emit()" nz-tooltip [nzTooltipTitle]="'TooltipReturn' | translate">
            <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
            {{ 'Return' | translate }}
          </button>
        </div>
        <div nz-col>
          <button nz-button nzType="default" class="default-button" (click)="saveData()" [disabled]="foreignAmountsIncomplete" nz-tooltip [nzTooltipTitle]="'TooltipSaveDraft' | translate">
            <span nz-icon nzType="save" nzTheme="outline"></span>
            {{ 'Save' | translate }}
          </button>
        </div>
        <div nz-col>
          <button nz-button nzType="primary" class="default-button" (click)="Submit()" [disabled]="foreignAmountsIncomplete" nz-tooltip [nzTooltipTitle]="'TooltipSubmitFinal' | translate">
            <span nz-icon nzType="upload" nzTheme="outline"></span>
            {{ 'Submit' | translate }}
          </button>
        </div>
      </div>

      <form nz-form [formGroup]="validateForm">
        <ng-container *ngIf="aliases && aliases.length > 0">
        <nz-table [nzShowPagination]="false" nzSize="middle" nzBordered [nzData]="aliases.controls" [nzScroll]="{ y: '240px' }" [nzNoResult]="emptyTpl">
          <ng-template #emptyTpl></ng-template>
          <thead>
            <tr>
              <th nzWidth="80px" style="text-align: center;">{{ 'InvoiceSerialNumber' | translate }}</th>
              <th nzWidth="150px" style="text-align: center;">
                <span style="color: #ff4d4f;">* </span>{{ 'InvoiceDate' | translate }}
              </th>
              <th nzWidth="150px" style="text-align: center;">
                <span style="color: #ff4d4f;">* </span>{{ 'InvoiceNo' | translate }}
              </th>
              <th nzWidth="160px" style="text-align: center;">
                {{ 'InvoiceAmountBeforeTax' | translate }}
              </th>
              <th nzWidth="120px" style="text-align: center;">
                {{ 'Taxes' | translate }}
              </th>
              <th nzWidth="200px" style="text-align: center;">
                <span style="color: #ff4d4f;">* </span>{{ 'TotalPriceIncludingTax' | translate }}
              </th>
              <th nzWidth="150px" style="text-align: center;">
                <span style="color: #ff4d4f;">* </span>{{ 'AutomatedInvoiceRecognition' | translate }}
              </th>
              <th nzWidth="60px" style="text-align: center;">{{ 'act' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container formArrayName="aliases">
              <tr [formGroupName]="i" *ngFor="let control of aliases.controls; let i = index" class="editable-row">
                <td>
                  <input type="text" nz-input formControlName="InvoiceSerialNumber" />
                </td>
                <td>
                  <div class="compare-container">
                    <nz-date-picker formControlName="InvoiceDate" [nzFormat]="dateFormat" style="width: 100%;"></nz-date-picker>
                    <div *ngIf="shouldShowComparison(control, 'InvoiceDate')" class="compare-text">
                      {{ 'AutomatedInvoiceRecognition' | translate }}: {{ getComparisonDisplay(control, 'InvoiceDate') }}
                    </div>
                  </div>
                </td>
                <td>
                  <div class="compare-container">
                    <input type="text" nz-input formControlName="InvoiceNo" />
                    <div *ngIf="shouldShowComparison(control, 'InvoiceNo')" class="compare-text">
                      {{ 'AutomatedInvoiceRecognition' | translate }}: {{ getComparisonDisplay(control, 'InvoiceNo') }}
                    </div>
                  </div>
                </td>
                <td>
                  <input type="text" nz-input formControlName="InvoiceAmountBeforeTax" (blur)="calculateSum(i); validateAndConfirm(i)" />
                </td>
                <td>
                  <input type="text" nz-input formControlName="Taxes" (blur)="calculateSum(i); validateAndConfirm(i)" />
                </td>
                <td>
                  <div class="compare-container">
                    <input type="text" nz-input formControlName="TotalAmount" />
                    <div *ngIf="shouldShowComparison(control, 'TotalAmount')" class="compare-text">
                      {{ 'AutomatedInvoiceRecognition' | translate }}: {{ getComparisonDisplay(control, 'TotalAmount') }}
                    </div>
                  </div>
                </td>
                <td style="text-align:center; vertical-align: middle;">
                  <!-- 初始狀態：可上傳識別 -->
                  <div *ngIf="control.get('editMode').value === 'initial'">
                    <nz-upload [nzShowUploadList]="false" [nzBeforeUpload]="beforeUploadAttachment.bind(this, i)">
                      <button nz-button nzType="default" nz-tooltip [nzTooltipTitle]="'TooltipRecognizeInvoice' | translate">
                        <span nz-icon nzType="scan" nzTheme="outline"></span>
                        {{ 'AutomatedInvoiceRecognition' | translate }}
                      </button>
                    </nz-upload>
                  </div>
                  <!-- 識別成功：顯示成功與重新識別、手動編輯入口 -->
                  <div *ngIf="control.get('editMode').value === 'recognized'">
                    <div style="display:flex; flex-direction:column; align-items:center; gap:4px;">
                      <div style="display:flex; align-items:center; gap:8px;">
                        <span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" style="font-size:16px;"></span>
                        <nz-upload [nzShowUploadList]="false" [nzBeforeUpload]="beforeUploadAttachment.bind(this, i)">
                          <button nz-button nzType="text" nzShape="circle" nz-tooltip [nzTooltipTitle]="'TooltipReRecognize' | translate">
                            <span nz-icon nzType="reload" nzTheme="outline"></span>
                          </button>
                        </nz-upload>
                      </div>
                      <div style="font-size:12px; color:#888;">
                        <a (click)="enableManualEdit(i)" nz-tooltip [nzTooltipTitle]="'TooltipEditRecognition' | translate">{{ 'TooltipEditRecognition' | translate }}</a>
                      </div>
                    </div>
                  </div>
                  <!-- 手動編輯模式：鎖定/還原/重新識別 -->
                  <div *ngIf="control.get('editMode').value === 'editing'">
                    <div style="display:flex; align-items:center; justify-content:center; gap:4px;">
                      <button nz-button nzType="text" nzShape="circle" (click)="toggleLock(i)" nz-tooltip [nzTooltipTitle]="(control.get('isLocked')?.value ? ('TooltipLocked' | translate) : ('TooltipUnlocked' | translate))">
                        <span nz-icon [nzType]="control.get('isLocked')?.value ? 'lock' : 'unlock'" nzTheme="outline"></span>
                      </button>
                      <button *ngIf="control.get('recognizedData').value" nz-button nzType="text" nzShape="circle" (click)="restoreRecognizedData(i)" nz-tooltip [nzTooltipTitle]="'TooltipRestoreRecognized' | translate">
                        <span nz-icon nzType="rollback" nzTheme="outline"></span>
                      </button>
                      <nz-upload [nzShowUploadList]="false" [nzBeforeUpload]="beforeUploadAttachment.bind(this, i)">
                        <button nz-button nzType="text" nzShape="circle" nz-tooltip [nzTooltipTitle]="'TooltipReRecognize' | translate">
                          <span nz-icon nzType="reload" nzTheme="outline"></span>
                        </button>
                      </nz-upload>
                    </div>
                  </div>
                </td>
                <td style="text-align:center; vertical-align: middle;">
                  <button nz-button nzType="text" nzShape="circle" nzDanger (click)="deleteRow(i)" nz-tooltip [nzTooltipTitle]="'TooltipDeleteRow' | translate">
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>
        </ng-container>
      </form>
    </nz-card>
  </div>
</nz-spin>
